import * as api from "../api"
export const getToken = () => async(dispatch) => {
    try {
        const { data } = await api.getToken()
        dispatch({ type: 'FETCH_TOKEN', payload: data });

    } catch (error) {
        console.log(error);
    }
}